// import React, { useState, useEffect } from "react";
// import { Upload, message, Modal } from "antd";
// import AIReportUpload from "../Quantum/AIReportUpload";
// import ReportUploadProgress from "../Quantum/ReportUploadProgress";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { APP_ROUTES } from "../PageRouting/AppRoutes";

// const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
// const log = (event, payload) => {
//   try { console.log("[VisionCareUpload]", event, payload || ""); } catch {}
// };
// const resolveFileType = (selectedFile) => {
//   const mimeToExt = (m) => (m === "image/png" ? ".png" : (m === "image/jpeg" || m === "image/jpg") ? ".jpg" : "");
//   const extFromName = selectedFile?.name?.includes(".") ? "." + selectedFile.name.split(".").pop().toLowerCase() : "";
//   const ct = selectedFile?.type || "application/octet-stream";
//   return extFromName || mimeToExt(ct);
// };

// export default function VisionCareUpload({ patientId, serviceName = "Vision Care", onStarted, initialVisible, onCloseInitial }) {
//   const [file, setFile] = useState(null);
//   const [uploadedImage, setUploadedImage] = useState(null);
//   const [requestId, setRequestId] = useState(null);
//   const [uploadUrls, setUploadUrls] = useState([]);
//   const [stage, setStage] = useState(initialVisible ? "instructions" : null);
//   const [progress, setProgress] = useState(0);
//   const [errorText, setErrorText] = useState("");
//    const navigate = useNavigate();

//   const endpointBase = process.env.REACT_APP_QUANTUMURL;
 
//   useEffect(() => {
//     console.log("[VisionCareUpload] initialVisible changed to:", initialVisible);
//     if (initialVisible) {
//       setStage("instructions");
//       log("initial_modal_open");
//     }
//     // FIXED: Don't reset stage to null when initialVisible is false
//     // The stage might be controlled by other flows (ai, progress, etc.)
//   }, [initialVisible]);
  
//   const generateUploadUrl = async (ct, selectedFile) => {
//     setProgress(10);
//     try { localStorage.setItem("quantumUploadSession", JSON.stringify({ requestId: null, serviceName, progress: 10, checkedOnce: false })); } catch {}
//     setStage("ai");
//     log("ai_modal_open");
//     const resolvedFileType = resolveFileType(selectedFile);
//     const payload = {
//       patientId,
//       serviceName,
//       files: [
//         {
//           fileNumber: 1,
//           fileType: resolvedFileType,
//           contentType: ct,
//         }
//       ]
//     };
//     try {
//       log("prepare_upload_start", payload);
//       await delay(10000);
//       const url = new URL("new_generate-resumable-url", endpointBase).toString();
//       const res = await axios.post(url, payload, { headers: { "Content-Type": "application/json" } });
//       const data = res.data;
//       const rid = data?.request_id || data?.requestId || data?.requestid || data?.requestID || null;
//       setRequestId(rid);
//       setUploadUrls(data?.upload_urls || []);
//       setProgress(50);
//       try { 
//           const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
//           localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, requestId: rid, serviceName, progress: 50 })); 
//       } catch {}
//       setStage("progress");
//       log("ai_modal_close");
//       log("progress_modal_open");
//       setErrorText("");
//       log("prepare_upload_success", { requestId: rid });
//       return { rid, urls: data?.upload_urls || [] };
//     } catch (err) {
//       setErrorText(String(err));
//       message.error("Failed to prepare upload. Please try again.");
//       setStage("ai");
//       log("prepare_upload_error", { message: String(err) });
//       localStorage.removeItem("quantumUploadSession");
//       return Promise.reject(err);
//     }
//   };

//   const uploadFile = async (urlsParam, fileParam) => {
//     const urls = Array.isArray(urlsParam) ? urlsParam : uploadUrls;
//     const useFile = fileParam || file;
//     if (!urls.length || !useFile) return;
//     setStage("progress");
//     log("progress_modal_open");
//     const ct = useFile?.type || "application/octet-stream";
//     try {
//       log("upload_put_start", { url: urls[0]?.url, contentType: ct });
//       await delay(10000);
//       await axios.put(urls[0].url, useFile, {
//         headers: { "Content-Type": ct },
//         timeout: 60000,
//         onUploadProgress: (evt) => {
//           if (evt && typeof evt.loaded === "number" && typeof evt.total === "number" && evt.total > 0) {
//             const fraction = evt.loaded / evt.total;
//             const pct = 50 + Math.min(30, Math.round(fraction * 30));
//             setProgress(pct);
//             try {
//               const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
//               localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: pct }));
//             } catch {}
//             log("upload_progress", { percent: pct });
//           }
//         },
//       });
//       setProgress(80);
//       try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 80 })); } catch {}
//       setErrorText("");
//       log("upload_put_success");
//     } catch (err) {
//       setErrorText(String(err));
//       // message.error("Upload failed. Please check your network and retry.");
//       log("upload_put_error", { message: String(err) });
//       localStorage.removeItem("quantumUploadSession");
//       throw err;
//     }
//   };

//   const checkUploaded = async (ridOverride) => {
//     const rid = ridOverride || requestId;
//     if (!rid) return;
//     setProgress((p) => (p < 90 ? 90 : p));
//     try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 90 })); } catch {}
//     const url = new URL("check-uploaded-files", endpointBase).toString();
//     const body = {
//       requestId: rid,
//       serviceName,
//       signedUrlCount: 1,
//       fileType: resolveFileType(file),
//     };
//     try {
//       log("verify_start", { requestId: rid });
//       await delay(10000);
//       const res = await axios.post(url, body, { headers: { "Content-Type": "application/json", accept: "application/json" } });
//       const data = res.data;
//       log("verify_response", data);
//       if (data) {
//         setProgress(100);
//         try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 100 })); } catch {}
//         setErrorText("");
//         log("verify_success", { requestId: rid });
//       } else {
//         setErrorText("Upload verification failed.");
//         message.error("Upload verification failed.");
//         log("verify_failed", { status: data?.status });
//       }
//     } catch (err) {
//       setErrorText(String(err));
//       message.error("Failed to verify upload.");
//       log("verify_error", { message: String(err) });
//       localStorage.removeItem("quantumUploadSession");
//       throw err;
//     }
//   };

//   const beforeUpload = (f) => {
//     const isImage = f.type === "image/png" || f.type === "image/jpeg" || f.type === "image/jpg";
//     if (!isImage) { message.error("Only PNG, JPG, or JPEG images are allowed!"); return false; }
//     const isLt5MB = f.size / 1024 / 1024 < 5;
//     if (!isLt5MB) { message.error("Image must be smaller than 5MB!"); return false; }
//     const reader = new FileReader();
//     reader.onload = () => { setUploadedImage(reader.result); };
//     reader.readAsDataURL(f);
//     setFile(f);
//     log("file_selected", { name: f?.name, type: f?.type, size: f?.size });
//     setStage("ai");
//     log("initial_modal_close");
//     if (typeof onStarted === "function") onStarted();
//     const ct = f.type || "application/octet-stream";
//     generateUploadUrl(ct, f)
//       .then(({ rid, urls }) => uploadFile(urls, f).then(() => rid))
//       .then((rid) => checkUploaded(rid))
//       .catch((err) => { setProgress(0); setStage("ai"); localStorage.removeItem("quantumUploadSession"); });
//     return false;
//   };

//   return (
//     <>
//       <Modal
//         open={stage === "instructions"}
//         onCancel={() => { setStage(null); log("initial_modal_cancel"); if (typeof onCloseInitial === "function") onCloseInitial(); }}
//         footer={null}
//         centered
//         width={600}
//         style={{ maxWidth: '100vw' }}
//         title="Upload Photo and Get an Instant Result"
//       >
//         <div className="flex flex-col md:flex-row gap-6 mt-4">
//           <ul className="list-disc text-xs md:text-sm text-textGray space-y-2 pl-5 flex-1">
//             {[
//               "Ensure good lighting",
//               "Hold the camera steady and avoid motion blur.",
//               "Focus clearly on the affected eye area.",
//               "Remove glasses, lens , or filters from the area.",
//               "Avoid shadows or overexposure on the eye.",
//               "Upload only one eye condition per image."
//             ].map((text, idx) => (
//               <li key={idx}>{text}</li>
//             ))}
//           </ul>
//           <div className="flex flex-col items-center gap-2 flex-1">
//             {uploadedImage ? (
//             <img
//               src={uploadedImage}
//               alt="Uploaded"
//               className="h-48 w-48 rounded object-cover"
//             />
//           ) : (
//             <div className="h-48 w-48 bg-gray-200 rounded flex flex-col items-center justify-center text-gray-500">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-16 w-16"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M3 7a4 4 0 014-4h10a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7z"
//                 />
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M8 13l2.5 3 3.5-4.5M21 15l-5.586-5.586M3 3l18 18"
//                 />
//               </svg>
//               <span className="text-xs mt-2">No Image</span>
//             </div>
//           )}
//           </div>
//         </div>
//         <div className="text-center mt-5">
//           <Upload showUploadList={false} accept=".png,.jpg,.jpeg" beforeUpload={beforeUpload}>
//             <button className="px-3 py-2 bg-[#004171] text-White text-xs md:text-sm rounded">Upload</button>
//           </Upload>
//         </div>
//       </Modal>
//       {stage !== "instructions" && (
//         <Upload showUploadList={false} accept=".png,.jpg,.jpeg" beforeUpload={beforeUpload}>
//           <button className="px-3 py-1 mt-1 bg-[#004171] text-White text-xs md:text-sm rounded">Upload</button>
//         </Upload>
//       )}
//       <AIReportUpload
//         solutionType='vision_care'
//         visible={stage === "ai"}
//         customHeaderTitle={errorText ? "Image upload failed !" : undefined}
//         customHeaderColor={errorText ? "#FA0505" : undefined}
//         customTitle={errorText ? "Oops, we couldn't upload your image. Please check your connection and try uploading again so our AI can generate your report." : undefined}
//         customDescription={errorText ? "Your image upload was unsuccessful-please upload the photo again !" : undefined}
//         customDescriptionColor={errorText ? "#FA0505" : undefined}
//         customButtonText={errorText ? "Upload Again" : undefined}
//         onCancel={() => { 
//           setStage(null); 
//           log("ai_modal_cancel"); 
//           setErrorText(""); 
//           try { 
//               const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
//               localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, checkedOnce: true })); 
//           } catch { }
//         }}
//         onExplore={() => {
//           if (errorText) {
//             setStage("instructions");
//             setErrorText("");
//             return;
//           }
//           const session = { requestId, serviceName, progress: progress || 10 };
//           try { localStorage.setItem("quantumUploadSession", JSON.stringify({ ...session, checkedOnce: true })); } catch {}
//           navigate("/", { state: { quantumUpload: session } });
//           log("ai_modal_explore", session);
//         }}
//         onWait={() => { setStage("progress"); log("ai_modal_wait"); log("progress_modal_open"); }}
//       />
//       <ReportUploadProgress
//         solutionType='vision_care'
//         visible={stage === "progress"}
//         onCancel={() => { setStage(null); log("progress_modal_cancel"); }}
//         progress={progress}
//         imageSrc={progress >= 80 && uploadedImage ? uploadedImage : undefined}
//         title={errorText ? "Upload failed" : undefined}
//         description={errorText ? errorText : undefined}
//         analyzingText={errorText ? "Please close and retry" : undefined}
//         onView={() => { navigate("/aireports", { state: { tab: "vision_care" } }); log("progress_modal_view_report", { tab: "vision_care" }); localStorage.removeItem("quantumUploadSession");  }}
//       />
//     </>
//   );
// }




import React, { useState, useEffect, useRef, useCallback } from "react";
import { message, Modal } from "antd";
import AIReportUpload from "../Quantum/AIReportUpload";
import ReportUploadProgress from "../Quantum/ReportUploadProgress";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../PageRouting/AppRoutes";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const log = (event, payload) => {
  try { console.log("[SkinCareUpload]", event, payload || ""); } catch {}
};
const resolveFileType = (selectedFile) => {
  const mimeToExt = (m) => (m === "image/png" ? ".png" : (m === "image/jpeg" || m === "image/jpg") ? ".jpg" : "");
  const extFromName = selectedFile?.name?.includes(".") ? "." + selectedFile.name.split(".").pop().toLowerCase() : "";
  const ct = selectedFile?.type || "application/octet-stream";
  return extFromName || mimeToExt(ct);
};

export default function VisionCareUpload({ patientId, sourcechannel, createdBy, serviceName = "Vision Care", onStarted, initialVisible, onCloseInitial }) {
  const [file, setFile] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const [uploadUrls, setUploadUrls] = useState([]);
  const [stage, setStage] = useState(initialVisible ? "instructions" : null);
  const [progress, setProgress] = useState(0);
  const [errorText, setErrorText] = useState("");

  // Camera states
  const [showCamera, setShowCamera] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const [capturedPhoto, setCapturedPhoto] = useState(null);
  const [facingMode, setFacingMode] = useState("environment");
  const [cameraError, setCameraError] = useState("");

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  // Live camera stream, kept in a ref so it can always be stopped — even from a stale callback,
  // after an unmount, or when getUserMedia resolves after the camera modal was already closed.
  const streamRef = useRef(null);
  const cameraWantedRef = useRef(false);
  const navigate = useNavigate();
  const endpointBase = process.env.REACT_APP_QUANTUMURL;

  useEffect(() => {
    if (initialVisible) {
      setStage("instructions");
      log("initial_modal_open");
    }
  }, [initialVisible]);

  // Start camera
  const releaseStream = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(t => t.stop());
      streamRef.current = null;
    }
    if (videoRef.current) videoRef.current.srcObject = null;
  };

  const startCamera = useCallback(async (mode = facingMode) => {
    setCameraError("");
    setCapturedPhoto(null);
    try {
      releaseStream();
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: mode, width: { ideal: 1280 }, height: { ideal: 720 } },
        audio: false,
      });
      // Camera modal closed while permission/startup was pending → don't leave the camera running
      if (!cameraWantedRef.current) {
        stream.getTracks().forEach(t => t.stop());
        return;
      }
      streamRef.current = stream;
      setCameraStream(stream);
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (err) {
      setCameraError("Camera access denied or not available. Please allow camera permission.");
      log("camera_error", String(err));
    }
  }, [cameraStream, facingMode]);

  // Assign stream to video element when both are ready
  useEffect(() => {
    if (showCamera && cameraStream && videoRef.current) {
      videoRef.current.srcObject = cameraStream;
    }
  }, [showCamera, cameraStream]);

  // Stop camera
  const stopCamera = useCallback(() => {
    releaseStream();
    setCameraStream(null);
  }, []);

  // Leaving the page (or the component unmounting for any reason) always turns the camera off
  useEffect(() => () => { cameraWantedRef.current = false; releaseStream(); }, []);

  const openCamera = () => {
    cameraWantedRef.current = true;
    setShowCamera(true);
    setCapturedPhoto(null);
    startCamera(facingMode);
  };

  const closeCamera = () => {
    cameraWantedRef.current = false;
    stopCamera();
    setShowCamera(false);
    setCapturedPhoto(null);
    setCameraError("");
  };

  const flipCamera = () => {
    const newMode = facingMode === "environment" ? "user" : "environment";
    setFacingMode(newMode);
    startCamera(newMode);
  };

  // Capture photo from video stream
  const capturePhoto = () => {
    if (!videoRef.current || !canvasRef.current) return;
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth || 640;
    canvas.height = video.videoHeight || 480;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const dataUrl = canvas.toDataURL("image/jpeg", 0.9);
    setCapturedPhoto(dataUrl);
    stopCamera(); // camera (and its light) off while the user reviews the shot
  };

  // Retake photo
  const retakePhoto = () => {
    cameraWantedRef.current = true;
    setCapturedPhoto(null);
    startCamera(facingMode);
  };

  // Convert dataURL to File and process
  const confirmCapturedPhoto = () => {
    if (!capturedPhoto) return;
    fetch(capturedPhoto)
      .then(r => r.blob())
      .then(blob => {
        const f = new File([blob], "captured.jpg", { type: "image/jpeg" });
        closeCamera();
        beforeUpload(f);
      });
  };

  const generateUploadUrl = async (ct, selectedFile) => {
    setProgress(10);
    try { localStorage.setItem("quantumUploadSession", JSON.stringify({ requestId: null, serviceName, progress: 10, checkedOnce: false })); } catch {}
    setStage("ai");
    log("ai_modal_open");
    const resolvedFileType = resolveFileType(selectedFile);
    const payload = {
      patientId,
      serviceName,
      files: [{ fileNumber: 1, fileType: resolvedFileType, contentType: ct }]
    };
    try {
      log("prepare_upload_start", payload);
      await delay(10000);
      const url = new URL("new_generate-resumable-url", endpointBase).toString();
      const res = await axios.post(url, payload, { headers: { "Content-Type": "application/json" } });
      const data = res.data;
      const rid = data?.request_id || data?.requestId || data?.requestid || data?.requestID || null;
      setRequestId(rid);
      setUploadUrls(data?.upload_urls || []);
      setProgress(50);
      try {
        const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
        localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, requestId: rid, serviceName, progress: 50 }));
      } catch {}
      setStage("progress");
      setErrorText("");
      log("prepare_upload_success", { requestId: rid });
      return { rid, urls: data?.upload_urls || [] };
    } catch (err) {
      setErrorText(String(err));
      message.error("Failed to prepare upload. Please try again.");
      setStage("ai");
      log("prepare_upload_error", { message: String(err) });
      localStorage.removeItem("quantumUploadSession");
      return Promise.reject(err);
    }
  };

  const uploadFile = async (urlsParam, fileParam) => {
    const urls = Array.isArray(urlsParam) ? urlsParam : uploadUrls;
    const useFile = fileParam || file;
    if (!urls.length || !useFile) return;
    setStage("progress");
    const ct = useFile?.type || "application/octet-stream";
    try {
      await delay(10000);
      await axios.put(urls[0].url, useFile, {
        headers: { "Content-Type": ct },
        timeout: 60000,
        onUploadProgress: (evt) => {
          if (evt?.loaded && evt?.total > 0) {
            const pct = 50 + Math.min(30, Math.round((evt.loaded / evt.total) * 30));
            setProgress(pct);
            try {
              const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
              localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: pct }));
            } catch {}
          }
        },
      });
      setProgress(80);
      try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 80 })); } catch {}
      setErrorText("");
    } catch (err) {
      setErrorText(String(err));
      localStorage.removeItem("quantumUploadSession");
      throw err;
    }
  };

  const checkUploaded = async (ridOverride) => {
    const rid = ridOverride || requestId;
    if (!rid) return;
    setProgress((p) => (p < 90 ? 90 : p));
    // The global progress banner only reads localStorage — keep it in step (same as LungsCare)
    try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 90 })); } catch {}
    const url = new URL("check-uploaded-files", endpointBase).toString();
    const body = {
      requestId: rid,
      serviceName,
      sourceChannel: sourcechannel,
      createdBy: createdBy,
      signedUrlCount: 1,
      fileType: resolveFileType(file),
    };
    try {
      await delay(10000);
      const res = await axios.post(url, body, { headers: { "Content-Type": "application/json", accept: "application/json" } });
      if (res.data) {
        setProgress(100);
        try { const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}"); localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, progress: 100 })); } catch {}
        setErrorText("");
      } else {
        setErrorText("Upload verification failed.");
        message.error("Upload verification failed.");
      }
    } catch (err) {
      setErrorText(String(err));
      message.error("Failed to verify upload.");
      localStorage.removeItem("quantumUploadSession");
      throw err;
    }
  };

  // Rejected files keep the modal open with the reason shown under the buttons (the antd toast
  // alone was easy to miss behind the modal, so a .webp just seemed to "do nothing").
  const rejectFile = (msg) => {
    message.error(msg);
    setFile(null);
    setUploadedImage(null);
    setErrorText(msg);
    setStage("instructions");
    return false;
  };

  const beforeUpload = (f) => {
    const isImage = f.type === "image/png" || f.type === "image/jpeg" || f.type === "image/jpg";
    if (!isImage) return rejectFile("Only PNG, JPG, or JPEG images are allowed!");
    const isLt5MB = f.size / 1024 / 1024 < 5;
    if (!isLt5MB) return rejectFile("Image must be smaller than 5MB!");
    const reader = new FileReader();
    reader.onload = () => { setUploadedImage(reader.result); };
    reader.readAsDataURL(f);
    setFile(f);
    setErrorText("");
    log("file_selected", { name: f?.name, type: f?.type, size: f?.size });
    // Show the image as a preview in the upload modal (same as SkinCare);
    // nothing goes to the backend until the user taps "Get Report".
    setStage("instructions");
    return false;
  };

  const handleGetReport = () => {
    if (!file) return;
    setStage("ai");
    if (typeof onStarted === "function") onStarted();
    const ct = file.type || "application/octet-stream";
    generateUploadUrl(ct, file)
      .then(({ rid, urls }) => uploadFile(urls, file).then(() => rid))
      .then((rid) => checkUploaded(rid))
      .catch(() => { setProgress(0); setStage("ai"); localStorage.removeItem("quantumUploadSession"); });
  };

  const handleFileChange = (e) => {
    const f = e.target.files?.[0];
    if (f) beforeUpload(f);
    e.target.value = "";
  };

  return (
    <>
      {/* ── INSTRUCTIONS MODAL ── */}
      <Modal
        open={stage === "instructions"}
        onCancel={() => {
          setStage(null);
          setFile(null);
          setUploadedImage(null);
          if (typeof onCloseInitial === "function") onCloseInitial();
        }}
        footer={null}
        centered
        width={600}
        style={{ maxWidth: '100vw' }}
        title={
  <div
    style={{
      fontFamily: 'Inter, sans-serif',
      fontWeight: 600,
      fontSize: '30px',
      lineHeight: '110%', // slightly more for 2 lines
      letterSpacing: '0.3%',
      background: 'var(--primary-gradient)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      maxWidth: '420px', // ✅ forces wrap into 2 lines
      whiteSpace: 'normal', // ✅ allow wrapping
      paddingBottom: '6px'
    }}
  >
    Upload photos & get an instant result
  </div>
}
       >
        <div className="flex flex-col md:flex-row gap-6 mt-4">
          <ul className="list-disc text-xs md:text-sm text-[#3B3B3B] marker:text-[#004276] space-y-2 pl-5 flex-1">
           {[
              "Ensure good lighting",
             "Hold the camera steady and avoid motion blur.",
               "Focus clearly on the affected eye area.",
               "Remove glasses, lens , or filters from the area.",
               "Avoid shadows or overexposure on the eye.",
               "Upload only one eye condition per image."
             ].map((text, idx) => <li key={idx}>{text}</li>)}
          </ul>
          <div className="flex flex-col items-center gap-2 flex-1">
            {uploadedImage ? (
              <img src={uploadedImage} alt="Uploaded" className="h-48 w-48 rounded object-cover" />
            ) : (
              <div className="h-48 w-48 bg-gray-200 rounded flex flex-col items-center justify-center text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7a4 4 0 014-4h10a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 13l2.5 3 3.5-4.5M21 15l-5.586-5.586M3 3l18 18" />
                </svg>
                <span className="text-xs mt-2">No Image</span>
              </div>
            )}
          </div>
        </div>

        <div className="mt-5 flex gap-3 justify-center flex-wrap">
          {/* Choose from files - FIXED with inline style */}
          <label style={file
            ? { padding: "9px 22px", backgroundColor: "#ffffff", color: "var(--color-brand-primary)", border: "1.5px solid var(--color-brand-primary)", fontSize: "14px", fontWeight: 600, borderRadius: "999px", cursor: "pointer", display: "inline-flex", alignItems: "center" }
            : { padding: "8px 20px", backgroundColor: "var(--color-brand-primary)", color: "#ffffff", fontSize: "14px", fontWeight: 600, borderRadius: "6px", cursor: "pointer", display: "inline-flex", alignItems: "center" }}>
            {file ? "Change Photo" : "Choose File"}
            <input type="file" accept="image/png,image/jpeg" style={{ display: "none" }} onChange={handleFileChange} />
          </label>

          {/* Open live camera — hidden once an image is picked (Change Photo covers re-picking) */}
          {!file && (
          <button
            style={{ padding: "8px 20px", backgroundColor: "var(--color-brand-primary)", color: "#ffffff", fontSize: "14px", fontWeight: 600, borderRadius: "6px", cursor: "pointer", border: "none", display: "inline-flex", alignItems: "center", gap: "6px" }}
            onClick={openCamera}
          >
            📷 Open Camera
          </button>
          )}

          {/* Get Report — shown only after an image is picked/captured; this starts the upload */}
          {file && (
            <button
              style={{ padding: "10px 32px", background: "var(--color-brand-green)", color: "#ffffff", fontSize: "15px", fontWeight: 700, borderRadius: "999px", cursor: "pointer", border: "none", display: "inline-flex", alignItems: "center", gap: "8px", boxShadow: "0 6px 16px rgba(0, 189, 127, 0.35)" }}
              onClick={handleGetReport}
            >
              Get Report <span aria-hidden="true">→</span>
            </button>
          )}
        </div>
        {errorText && (
          <p style={{ color: "#FA0505", fontSize: "13px", textAlign: "center", marginTop: "10px" }}>{errorText}</p>
        )}
      </Modal>

      {/* ── CAMERA MODAL ── */}
      <Modal
        open={showCamera}
        onCancel={closeCamera}
        footer={null}
        centered
        width={560}
        style={{ maxWidth: '100vw' }}
        title="Take a Photo"
        destroyOnClose
      >
        <div className="flex flex-col items-center gap-4">
          {cameraError ? (
            <div className="text-red-500 text-sm text-center p-4">{cameraError}</div>
          ) : capturedPhoto ? (
            /* Show captured photo for confirmation */
            <>
              <img src={capturedPhoto} alt="Captured" className="w-full max-h-72 object-contain rounded-lg border" />
              <div className="flex gap-3 w-full justify-center">
                <button
                  style={{ padding: "8px 20px", backgroundColor: "#6B7280", color: "#ffffff", fontSize: "14px", fontWeight: 600, borderRadius: "999px", cursor: "pointer", border: "none", display: "inline-flex", alignItems: "center", gap: "6px" }}
                  onClick={retakePhoto}
                >
                  🔄 Retake
                </button>
                <button
                  style={{ padding: "8px 20px", backgroundColor: "var(--color-brand-primary)", color: "#ffffff", fontSize: "14px", fontWeight: 600, borderRadius: "999px", cursor: "pointer", border: "none", display: "inline-flex", alignItems: "center", gap: "6px" }}
                  onClick={confirmCapturedPhoto}
                >
                  ✅ Use This Photo
                </button>
              </div>
            </>
          ) : (
            /* Live camera preview */
            <>
              <div className="relative w-full rounded-lg overflow-hidden bg-black" style={{ aspectRatio: '4/3' }}>
                <video
                  ref={videoRef}
                  autoPlay
                  playsInline
                  muted
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex gap-3 justify-center w-full">
                {/* Flip camera */}
                <button
                  style={{ padding: "8px 20px", backgroundColor: "#6B7280", color: "#ffffff", fontSize: "14px", fontWeight: 600, borderRadius: "999px", cursor: "pointer", border: "none", display: "inline-flex", alignItems: "center", gap: "6px" }}
                  onClick={flipCamera}
                >
                  🔃 Flip
                </button>
                {/* Capture */}
                <button
                  style={{ padding: "8px 20px", backgroundColor: "var(--color-brand-primary)", color: "#ffffff", fontSize: "14px", fontWeight: 600, borderRadius: "999px", cursor: "pointer", border: "none", display: "inline-flex", alignItems: "center", gap: "6px" }}
                  onClick={capturePhoto}
                >
                  📸 Capture
                </button>
              </div>
              <p className="text-xs text-gray-400 text-center">Position the affected skin area in frame, then click Capture</p>
            </>
          )}
        </div>
        {/* Hidden canvas for capturing frames */}
        <canvas ref={canvasRef} style={{ display: "none" }} />
      </Modal>

      {/* Upload button outside modal */}
      {stage !== "instructions" && (
        <div className="flex gap-2 mt-1 flex-wrap">
          <label className="px-3 py-1 bg-[#004276] hover:bg-[#003360] text-white text-xs md:text-sm rounded cursor-pointer">
            Upload
            <input type="file" accept="image/png,image/jpeg" style={{ display: "none" }} onChange={handleFileChange} />
          </label>
          <button
            className="px-3 py-1 bg-[#004276] hover:bg-[#003360] text-white text-xs md:text-sm rounded cursor-pointer border-none"
            onClick={openCamera}
          >
            📷 Camera
          </button>
        </div>
      )}

      <AIReportUpload
        solutionType='vision_care'
        visible={stage === "ai"}
        customHeaderTitle={errorText ? "Image upload failed !" : undefined}
        customHeaderColor={errorText ? "#FA0505" : undefined}
        customTitle={errorText ? "Oops, we couldn't upload your image. Please check your connection and try uploading again so our AI can generate your report." : undefined}
        customDescription={errorText ? "Your image upload was unsuccessful-please upload the photo again !" : undefined}
        customDescriptionColor={errorText ? "#FA0505" : undefined}
        customButtonText={errorText ? "Upload Again" : undefined}
        onCancel={() => {
          setStage(null);
          setErrorText("");
          try {
            const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
            localStorage.setItem("quantumUploadSession", JSON.stringify({ ...sess, checkedOnce: true }));
          } catch {}
        }}
        onExplore={() => {
          if (errorText) { setStage("instructions"); setErrorText(""); return; }
          const session = { requestId, serviceName, progress: progress || 10 };
          try { localStorage.setItem("quantumUploadSession", JSON.stringify({ ...session, checkedOnce: true })); } catch {}
          
          navigate("/", { state: { quantumUpload: session } });
        }}
        onWait={() => { setStage("progress"); }}
      />

      <ReportUploadProgress
        solutionType='vision_care'
        visible={stage === "progress"}
        onCancel={() => { setStage(null); }}
        progress={progress}
        imageSrc={progress >= 80 && uploadedImage ? uploadedImage : undefined}
        title={errorText ? "Upload failed" : undefined}
        description={errorText ? errorText : undefined}
        analyzingText={errorText ? "Please close and retry" : undefined}
        onView={() => {
          
          navigate("/aireports", { state: { tab: "vision_care" } });
          localStorage.removeItem("quantumUploadSession");
        }}
      />
    </>
  );
} 